import "@/utils/zod";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LicenseInfo } from "@mui/x-license";

import App from "./app";

import "@packsize/theme/fonts.css";
import "./index.css";

LicenseInfo.setLicenseKey(import.meta.env?.VITE_MUI_LICENSE_KEY);

// `react-grid-layout` tries to read from `process.env` for debugging, but vite
// doesn't set up process.env, so set it up ourselves.
// https://github.com/react-grid-layout/react-grid-layout/issues/2266
(window as unknown as { process: { env: Record<string, string | undefined> } }).process ??= { env: {} };

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
